<app-spinner
    [show]="!flagLoaded"
    [type]="'fullscreen'"
    [size]="'large'"
    [color]="'#B1476A'"
    [trackColor]="'#4CA7C8'"
    [text]="'Cargando cuenta...'"
    [showText]="true"
    [blurBackground]="true">
</app-spinner>

<div class="cuenta-wrapper" *ngIf="flagLoaded">
  <div class="cuenta-container">
    <div class="cuenta-grid">
      <!-- Columna 1: Avatar y subida de imagen -->
      <div class="cuenta-col">
        <div class="avatar-section" matRipple [matRippleCentered]="centered" [matRippleDisabled]="disabled"
             [matRippleUnbounded]="unbounded" [matRippleRadius]="radius" [matRippleColor]="color">
          <ng-container *ngIf="this.usuario.avatar == 'av-1.png' else elseTemplate">
            <img [src]="imageUrl" class="avatar-img" />
          </ng-container>
          <ng-template #elseTemplate>
            <img [src]=" this.usuario._id | mediaUsuariosPipe: this.usuario.avatar | safe"
                 [alt]="this.usuario.avatar" class="avatar-img">
          </ng-template>
        </div>

        <form [formGroup]="formImg" (ngSubmit)="guardarImg()" class="upload-form">
          <!-- Selector de archivo estilizado -->
          <div class="custom-file">
            <input [disabled]="condition" class="file-input-hidden" type="file" formControlName="imagen"
                   #fileInput accept="image/jpeg, image/jpg, image/png"
                   (change)="onChangeFile(fileInput.files[0], $event)" id="fileUpload" />
            <label for="fileUpload" class="file-label">
              <span class="material-icons">cloud_upload</span>
              <span>Seleccionar imagen</span>
            </label>
            <span class="file-name" *ngIf="fileName !== 'No file selected'">{{ fileName }}</span>
          </div>

          <button [disabled]="!formImg.valid || this.cargandoArchivo" type="submit" class="btn-primary-pill">
            <span class="material-icons">save</span>
            Guardar Foto
          </button>
        </form>
      </div>

      <!-- Columna 2: Datos personales -->
      <div class="cuenta-col">
        <div class="data-card">
          <h4>Datos Personales</h4>
          <h3 *ngIf="this.usuario.nombrePersona">{{ this.usuario.nombrePersona }} {{ this.usuario.apellidoPersona }}</h3>
          <p *ngIf="this.usuario.presentacion" class="presentacion-text">{{ this.usuario.presentacion }}</p>
          <ul class="info-list">
            <li *ngIf="this.usuario.telefono">
              <span class="material-icons">phone</span>
              <span>Número de teléfono: </span>{{ this.usuario.paisCodeArea }} - {{ this.usuario.telefono }}
            </li>
            <li *ngIf="this.usuario.email">
              <span class="material-icons">email</span>
              <span>Email: </span>{{ this.usuario.email }}
            </li>
            <li *ngIf="this.usuario.birth">
              <span class="material-icons">cake</span>
              <span>Fecha de Nacimiento:</span> {{ this.usuario.birth | date: 'dd-MM-yyyy':'UTC'}}
            </li>
          </ul>

          <div class="botones-accion">
            <button class="btn-primary-pill" (click)="this.openDialogModificarClave()">
              <span class="material-icons">lock</span>
              Modificar Clave
            </button>
            <!-- Nota: Borrado el botón de Modificar presentación porque no está activo -->
          </div>
        </div>
      </div>

      <!-- Columna 3: Datos afiliado Gecros -->
      <div class="cuenta-col" *ngIf="flagLoadedGecros && gecrosAfiliado">
        <div class="data-card">
          <h4>Datos Afiliado Gecros</h4>
          <h3 *ngIf="this.gecrosAfiliado.nombreAfiliado">{{ this.gecrosAfiliado.nombreAfiliado }}</h3>
          <ul class="info-list">
            <li *ngIf="this.gecrosAfiliado.email">
              <span class="material-icons">email</span>
              Email: <strong>{{this.gecrosAfiliado.email}}</strong>
            </li>
            <li *ngIf="this.gecrosAfiliado.numeroAfiliado">
              <span class="material-icons">badge</span>
              Nro. Afiliado: <strong>{{this.gecrosAfiliado.numeroAfiliado}}</strong>
            </li>
            <li *ngIf="sedeAfiliado">
              <span class="material-icons">business</span>
              Sede: <strong>{{sedeAfiliado}}</strong>
            </li>
            <li *ngIf="this.gecrosAfiliado.plan">
              <span class="material-icons">assignment</span>
              Plan: <strong>{{this.gecrosAfiliado.plan}}</strong>
            </li>
            <li *ngIf="this.gecrosAfiliado.estado">
              <span class="material-icons">info</span>
              Estado: <strong>{{this.gecrosAfiliado.estado}}</strong>
            </li>
            <li *ngIf="this.gecrosAfiliado.convenio">
              <span class="material-icons">gavel</span>
              Convenio: <strong>{{this.gecrosAfiliado.convenio}}</strong>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>